export default "__VITE_ASSET__JkdxpPyW__"